export const selectDepartmentModalTranslationEN = {
  SelectDepartmentModal: {
    selection: 'Select',
  },
};
